/* eslint-disable camelcase */
import { getTeamLabelByNumber } from '../../utils/utils'
import { addZero } from '../../../../../utils/filters'

const zonesByTeamSide = {
  1: {
    notReversed: {
      0: 'defense',
      2: 'center'
    },
    reversed: {
      2: 'center',
      4: 'defense'
    }
  },
  2: {
    reversed: {
      0: 'defense',
      2: 'center'
    },
    notReversed: {
      2: 'center',
      4: 'defense'
    }
  }
}
export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { isShootoutSeriesFormat } = this
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        has_timer,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      if (isShootoutSeriesFormat) return

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set
      })

      this.setIngameProperty({
        property: 'hasTimer',
        value: has_timer
      })

      if (!is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    'PLAYERS_ON_FIELD' () {
      const { isShootoutSeriesFormat } = this

      if (!isShootoutSeriesFormat) return

      this.setPeriod({ GamePeriod: 1, ScoreHome: 0, ScoreAway: 0 })
      this.setPenaltyShootouts({ GamePeriod: 1 })
    },
    'START_PERIOD' ({ GamePeriod }) {
      const { getIngameData } = this
      const { isReversedField } = getIngameData

      if (GamePeriod === 1) return

      this.setIngameProperty({
        property: 'isReversedField',
        value: !isReversedField
      })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      if (TeamNumber === 2) {
        this.setIngameProperty({
          property: 'isReversedField',
          value: true
        })
      }
    },
    'RED_CARD' ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'RED_CARD_SUBSTITUTION_RIGHT' ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'TEAM_CORRECTION' ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'SECOND_YELLOW_CARD' ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'SECOND_YELLOW_CARD_SUBSTITUTION_RIGHT' ({ extra: { team1, team2 } }) {
      if (team1 && team2) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'GOAL_CONFIRMED' (event) {
      this.setScore(event)
    },
    'PENALTY_FINISH' (event) {
      this.editPeriodScore(event)
    },
    'MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'MEDICAL_CREW' (event) {
      const { getCurrentPeriod } = this
      const { GamePeriod } = event

      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'MEDICAL_CREW',
        period: GamePeriod || getCurrentPeriod,
        type: 'increment',
        key: 'commonValue'
      })
    },
    'CANCEL' (event) {
      const { RelatedEventNumber, GamePeriod } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { EventCode, TeamNumber } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (['MEDICAL_CREW'].includes(EventCode)) {
        this.updateStatistic({
          statisticType: 'defaultStatistic',
          property: EventCode,
          period: GamePeriod || getCurrentPeriod,
          type: 'decrement',
          key: 'commonValue'
        })
      }

      if (EventCode === 'START_SHOOTOUT') {
        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod)
        this.setStatisticPeriod(getCurrentPeriod)
      }

      if (
        [
          'RED_CARD',
          'RED_CARD_SUBSTITUTION_RIGHT',
          'SECOND_YELLOW_CARD',
          'SECOND_YELLOW_CARD_SUBSTITUTION_RIGHT'
        ].includes(EventCode)
      ) {
        const { extra } = event

        if (!extra) return

        const { team1, team2 } = extra

        if (team1 && team2) {
          this.setIngameProperty({
            property: 'playersCount',
            value: {
              home: team1,
              away: team2
            }
          })
        }
      }

      this.setScore(event)
      this.setCanceled(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'SAFE_ZONE' (event) {
      const { TeamNumber } = event

      const { homeTeamTitle, awayTeamTitle } = this
      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${this.$t('football.zone.possession.defense')} / ${teamTitle}`
    },
    'POSESSION_1' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, homeTeamTitle } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('football.shootout.possession.title')} / ${homeTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${homeTeamTitle}`
    },
    /**
     * @return {string}
     */
    'POSESSION_2' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, awayTeamTitle } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]

      if (overriddenType === 'shootout') {
        return `${this.$t('football.shootout.possession.title')} / ${awayTeamTitle}`
      }

      if (!event.eventInfo) return ''

      return `${event.eventInfo.title} / ${awayTeamTitle}`
    },
    /**
     * @return {string}
     */
    // 'ADJUST_POINTS' () {
    //   return this.$t('trader.adjust.score.football')
    // },
    'ADJUST_POINTS' (event) {
      return this.$t('trader.adjust.points.title')
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle } = this
      const { type, overriddenType } = getMatchPeriods[GamePeriod]

      if (!TeamNumber) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      if (overriddenType === 'shootout') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.penaltyshootout')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime.football')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'DANGEROUS_FREE_KICK' () {
      return '_red'
    },
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    },
    'TEAM_CORRECTION' () {
      return '_green'
    }
  },
  eventPlaytimeFunction (event) {
    const { Playtime, GamePeriod } = event

    if (!Playtime || !GamePeriod) return '00:00'

    const { getFormats } = this.getters
    const {
      matchFormat: {
        count: mainCount,
        duration: mainDuration
      },
      overtimeFormat: {
        duration: overtimeDuration
      }
    } = getFormats
    const isOvertime = GamePeriod > mainCount
    const secondsCount = Playtime / 1000
    const minutes = Math.floor(secondsCount / 60)
    const seconds = Math.floor(secondsCount % 60)
    let needToTransform = false

    if (!isOvertime) {
      const compareValue = GamePeriod * mainDuration

      needToTransform = compareValue < minutes || (compareValue === minutes && seconds > 0)
    } else {
      const compareValue = mainCount * mainDuration + (GamePeriod - mainCount) * overtimeDuration

      needToTransform = compareValue < minutes || (compareValue === minutes && seconds > 0)
    }

    if (!needToTransform) return `${addZero(minutes)}:${addZero(seconds)}`

    if (!isOvertime) {
      const maintimeMinutes = mainDuration * GamePeriod

      return `${maintimeMinutes}:00 (${minutes - maintimeMinutes}:${addZero(seconds)})`
    }

    const overtimrMinutes = mainDuration * mainCount + overtimeDuration * (GamePeriod - mainCount)

    return `${overtimrMinutes}:00 (${minutes - overtimrMinutes}:${addZero(seconds)})`
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.penaltyshootout')

    if (type === 'overtime') return this.$t('trader.win.overtime.football')

    return this.$t('trader.win.maintime')
  }
  // eventSounds: {
  //   /**
  //    * @return {string}
  //    */
  //   'GOAL' ({ GamePeriod }) {
  //     const { getStoredSounds } = this
  //     console.log(123123123)
  //
  //     switch (GamePeriod) {
  //       case 1:
  //         return 'https://streaming.slsndbx.com/ngenix-web/images/146/98/30e451cebf91ce950426656b7e567e576e174c33.mp3'
  //       case 2:
  //         return 'https://streaming.slsndbx.com/ngenix-web/images/146/98/30e451cebf91ce950426656b7e567e576e174c33.mp3'
  //       case 3:
  //         return 'https://streaming.slsndbx.com/ngenix-web/images/146/98/30e451cebf91ce950426656b7e567e576e174c33.mp3'
  //       case 4:
  //         return 'https://streaming.slsndbx.com/ngenix-web/images/146/98/30e451cebf91ce950426656b7e567e576e174c33.mp3'
  //       default:
  //         return getSound(getStoredSounds['START_PERIOD'])
  //     }
  //   },
  //   /**
  //    * @return {string}
  //    */
  //   'FINISH_PERIOD' ({ GamePeriod }) {
  //     const { getStoredSounds } = this
  //
  //     switch (GamePeriod) {
  //       case 1:
  //         return 'http://a.sportlevel.com/sounds/FIRST_HALF_ENDED.mp3'
  //       case 2:
  //         return 'http://a.sportlevel.com/sounds/SECOND_HALF_ENDED.mp3'
  //       case 3:
  //         return 'http://a.sportlevel.com/sounds/FIRST_EXTRA_TIME_ENDED.mp3'
  //       case 4:
  //         return 'http://a.sportlevel.com/sounds/SECOND_EXTRA_TIME_ENDED.mp3'
  //       default:
  //         return getSound(getStoredSounds['FINISH_PERIOD'])
  //     }
  //   },
  //   'FINISH_OVERTIME_PERIOD' ({ GamePeriod }) {
  //     const { getStoredSounds } = this
  //
  //     switch (GamePeriod) {
  //       case 1:
  //         return 'http://a.sportlevel.com/sounds/FIRST_HALF_ENDED.mp3'
  //       case 2:
  //         return 'http://a.sportlevel.com/sounds/SECOND_HALF_ENDED.mp3'
  //       case 3:
  //         return 'http://a.sportlevel.com/sounds/FIRST_EXTRA_TIME_ENDED.mp3'
  //       case 4:
  //         return 'http://a.sportlevel.com/sounds/SECOND_EXTRA_TIME_ENDED.mp3'
  //       default:
  //         return getSound(getStoredSounds['FINISH_PERIOD'])
  //     }
  //   }
  // }
}
